import PageShell from "./PageShell";
import CoachSection from "../components/landing/CoachSection";

const CoachPage = () => (
  <PageShell title="Meet Your Coach">
    <CoachSection />
  </PageShell>
);

export default CoachPage;
